import { render, staticRenderFns } from "./BlockFileList.vue?vue&type=template&id=c85ce9dc&scoped=true"
import script from "./BlockFileList.vue?vue&type=script&lang=js"
export * from "./BlockFileList.vue?vue&type=script&lang=js"
import style0 from "./BlockFileList.vue?vue&type=style&index=0&id=c85ce9dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85ce9dc",
  null
  
)

export default component.exports